import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import QuestionForm, {
	Question,
} from "src/components/forms/QuestionForm/QuestionForm";
import { TaskFormOptions } from "src/components/tasks/TaskForm";
import Form from "src/components/tasks/TaskForm/Form";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";

const InterviewForm = ({ hideButtons }: TaskFormOptions) => {
	const { t } = useTranslation(["forms", "buttons"]);
	const { task, actions, current } = useTaskForm();
	const questions = task?.questions || [];
	const isEmpty = questions?.length === 0 || questions[0].title === "";

	const getAutoFillQuery = () => {
		if (task?.category_id) {
			return `category_id=${task?.category_id}`;
		}

		if (task?.category) {
			return "blank=1";
		}

		return "";
	};

	const handleAddNewQuestion = () => {
		actions.set({
			questions: [
				...(task.questions || []),
				{
					title: "",
					answers: [],
				} as Question,
			],
		});
	};

	useEffect(() => {
		if (!task?.questions || !task?.questions?.length) {
			handleAddNewQuestion();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Form
			{...{ hideButtons }}
			title={t("title", {
				ns: "forms",
				keyPrefix: "interview-form",
			})}
			onSubmit={async () => {
				actions.updateCurrent(current + 1);
			}}
			value={{}}
			nextDisabled={false}
			nextButtonLabel={
				!isEmpty
					? t("next-step", { ns: "buttons" })
					: t("skip", { ns: "buttons" })
			}
		>
			{() => {
				return (
					<>
						<p>
							{t("description", {
								ns: "forms",
								keyPrefix: "interview-form",
							})}
						</p>

						<div className="flex flex-col gap-2">
							{(questions || []).map(
								(question: Question, index: number) => (
									<QuestionForm
										key={`question-${index}`}
										input={{
											label: t("question-label", {
												ns: "forms",
												keyPrefix: "interview-form",
												count: index + 1,
											}),
										}}
										settings={{
											addOnFocus: task?.id ? false : true,
										}}
										autoFillQuery={getAutoFillQuery()}
										value={question}
										onChange={(value) => {
											if (!value) {
												const questions =
													task?.questions?.filter(
														(_: any, i: number) =>
															i !== index
													);
												actions.set({
													questions,
												});
												return;
											}
											actions.set({
												questions: task.questions.map(
													(
														item: Question,
														i: number
													) => {
														if (i === index)
															return value;

														return item;
													}
												),
											});
										}}
									/>
								)
							)}
						</div>

						<div className="flex justify-center">
							<Button
								disabled={
									questions &&
									questions.length &&
									!questions[questions.length - 1].title
								}
								onClick={handleAddNewQuestion}
							>
								<i className="fas fa-plus mr-2"></i>
								{t("add-question", {
									ns: "forms",
									keyPrefix: "interview-form",
								})}
							</Button>
						</div>
						<p className="mt-4">
							{t("description", {
								ns: "forms",
								keyPrefix: "interview-form",
							})}
						</p>
					</>
				);
			}}
		</Form>
	);
};

export default InterviewForm;
